/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Price_H2Inputs */

const es_l7_price_h2 = /** @type {(inputs: L7_Price_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + IVA. Y nada de cuotas escondidas.`)
};

const gl_l7_price_h2 = /** @type {(inputs: L7_Price_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + IVE. E nada de cuotas agochadas.`)
};

const en_l7_price_h2 = /** @type {(inputs: L7_Price_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + VAT. No hidden fees.`)
};

/**
* | output |
* | --- |
* | "15% + VAT. No hidden fees." |
*
* @param {L7_Price_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_price_h2 = /** @type {((inputs?: L7_Price_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Price_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_price_h2(inputs)
	if (locale === "en") return en_l7_price_h2(inputs)
	return es_l7_price_h2(inputs)
});